<template>
  <div class="account-message">
    <template v-for="accountMessage in accountMessages">
      <!-- Type: banner -->
      <template v-if="accountMessage.type.indexOf('banner') != -1">
        <div class="account-message-box" transition="expand">
          <div class="account-message-banner">
            <span v-on:click="dismissAccountMessage(accountMessage)" class="fa fa-times close-button interactive-cursor"></span>
            <i class="fa fa-bell"></i>&nbsp;
            <h5>{{ accountMessage.name }}</h5>
            <p>{{ accountMessage.createdAt | date_format }}</p>
            <hr/>
            <p>{{{ accountMessage.message }}}</p>
          </div>
        </div>
      </template>
      <!-- Type: loginMessage -->
      <modal v-if="accountMessage.type.indexOf('loginMessage') != -1">
        <template slot="header">
          {{ accountMessage.name }}
        </template>
        <span slot="x-button"></span>
        <template slot="body">
          <i class="fa fa-bell"></i>&nbsp;
          <p>{{ accountMessage.createdAt | date_format }}</p>
          <hr/>
          <p>{{{ accountMessage.message }}}</p>
        </template>
        <template slot="footer">
          <button type="button" class="btn btn-info pull-left" v-on:click="dismissAccountMessage(accountMessage)" data-dismiss="modal">Accept</button>
        </template>
      </modal>
    </template>
  </div>
</template>

<script>
import Modal from '../Modal'
export default {
  name: 'AccountMessage',
  components: {
    Modal
  },
  data () {
    return {
      accountMessages: []
    }
  },
  ready () {
    this.getAccountMessages()
  },
  methods: {
    getAccountMessages () {
      let authType = 'private'
      this.$http.get(`${authType}/account-messages`, {}).then((response, status, request) => {
        this.accountMessages = response.data.accountMessages
        this.$nextTick(function () {
          $('.modal').modal({backdrop: 'static', keyboard: false})
        })
      })
    },
    dismissAccountMessage (message) {
      let authType = 'private'
      this.$http.post(`${authType}/dismiss-account-message`, { message }).then((response, status, request) => {
        this.accountMessages.splice(this.accountMessages.indexOf(message), 1)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccountMessage.vue?ce4060e0